import React, {
  useContext
} from 'react'
import tim from '../assets/yuting_.ico'
import {
    Typography,
    AppBar,
    Toolbar,
    Container,
    makeStyles,
    Avatar,
    Grid,
    Select,
    MenuItem,
    IconButton 
 } from '@material-ui/core'
 import { checkBrowser } from '../core/shared/commFunSet';
 import { ObjectDetectRefContext } from '../core/services/ObjectDetectRefService'
 import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
 import LanguageIcon from '@material-ui/icons/Language';

 //
// IMPORT ZONE
//

const useStyles = makeStyles((theme) => ({
    appBar: {
        background: '#7EAED9'
    }
}))

const Footer = () => {
    const classes = useStyles()
    const { 
      speaker,
      browserVoiceList, 
      setCurrentLang,
      currentVoice,
      setCurrentVoice,
    } = useContext(ObjectDetectRefContext)
    
    const handleVoiceLangOnChange = (lang, voice) => {
      setCurrentLang(lang)
      setCurrentVoice(voice)
      updateSpeech(voice, lang)
    }

    const updateSpeech = (voice, lang) => {
      speaker.setLanguage(lang)
      speaker.setVoice(voice)
    } 

    return (
      <AppBar position="static" className={classes.appBar}>
          <Toolbar>
        <Container maxWidth="xl" style={{ padding: '5px 0px'}}>
          <Grid >
              <Grid container direction="column" alignItems="center">

                  <Avatar src={tim}/>
                  <Typography variant="body1" color="inherit">
                  &nbsp; 阿葛棒棒的物件偵測 © {new Date().getFullYear()} 
                  </Typography>
              </Grid>
              <Grid container justify="center" >
                 <Grid item alignItems="center">
                   &nbsp;
                   <Select value={currentVoice}>
                          {browserVoiceList.voices && browserVoiceList.voices.map( (d,index) => (
                            <MenuItem 
                            key={index} 
                            value={`${d.name}`} 
                            onClick={()=> handleVoiceLangOnChange(`${d.lang}`, `${d.name}`)}
                            >{d.name} / {d.lang}</MenuItem>
                          ))}
                        </Select> 
                          &nbsp;
                          <IconButton  
                             startIcon={<RecordVoiceOverIcon/>}
                             // variant="contained"
                             color="default"
                             component="span"
                              onClick={() => {
                                speaker.speak(
                               {
                                 text: '內湖成五好帥! 歡迎來到物件偵測辨識的小天地 希望你玩得開心啊啊阿阿阿阿!', //prediction.class,//'五郎喔',
                                 queue: false,
                               }
                              ).then(() => { });
                              }}>
                              <RecordVoiceOverIcon/>
                          </IconButton>
                 </Grid>
              </Grid>
              <Grid container justify="flex-end">
                 <LanguageIcon/> <span style={{ textAlign:'justigy'}}>{<>{checkBrowser()}</>}</span>
              </Grid>
            </Grid>
          </Container>
          </Toolbar>
      </AppBar>
    )
}

export default Footer
